"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalileanMining = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("./PreludeCard");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
var CardRenderer_1 = require("../../cards/render/CardRenderer");
var GalileanMining = (function (_super) {
    __extends(GalileanMining, _super);
    function GalileanMining() {
        return _super.call(this, {
            name: CardName_1.CardName.GALILEAN_MINING,
            tags: [Tags_1.Tags.JOVIAN],
            metadata: {
                cardNumber: 'P13',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.titanium(2);
                    }).br;
                    b.megacredits(-5);
                }),
                description: 'Increase your titanium production 2 steps. Pay 5 M€.',
            },
        }) || this;
    }
    GalileanMining.prototype.canPlay = function (player) {
        return player.canAfford(5);
    };
    GalileanMining.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.TITANIUM, 2);
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 5));
        return undefined;
    };
    return GalileanMining;
}(PreludeCard_1.PreludeCard));
exports.GalileanMining = GalileanMining;
//# sourceMappingURL=GalileanMining.js.map